var varitaionOne = {
  className: 'text-card',
  ariaLabel: 'Text Card',
  headingText: 'Our Newest Products Quisque Vitae Justo',
  subHeadingText: 'LOREM IPSUM DOLOR SIT',
  descriptionText: {
    data: {},
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: 'Lorem ipsum dolor sit amet,magna.',
        nodeType: 'text'
      }],
      nodeType: 'paragraph'
    }, {
      data: {},
      content: [{
        data: {},
        marks: [],
        value: 'Maecenas mi urna, efficitur sit ametVestibulum ut magna metus.',
        nodeType: 'text'
      }],
      nodeType: 'paragraph'
    }],
    nodeType: 'document'
  },
  buttonText: 'Action',
  imageSource: './images/dummies/320.png',
  imageSourceSet: './images/dummies/1280.png 1024w, ./images/dummies/640.png 640w, ./images/dummies/320.png 320w',
  sizes: '(min-width: 36em) 33.3vw, 100vw',
  placeholderSrc: './images/image-placeholder.png',
  alt: 'Dummy Image',
  cta: []
};
var varitaionTwo = {
  className: 'text-card',
  ariaLabel: 'Text Card',
  headingText: 'Your Pet, Our Priority'
};
var variationThree = {
  className: 'text-card',
  ariaLabel: 'Text Card',
  headingText: 'Your Pet, Our Priority'
};
export { varitaionOne, varitaionTwo, variationThree };